module.exports = __webpack_public_path__ + "img/winerackdog33.4f787cb3.jpg";